module.exports = __webpack_public_path__ + "static/media/wordpress-blue.ad28d74c.svg";